import React from 'react';

const DiscountsPage = React.lazy(() => import('./DiscountsPage'));

const DiscountsConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/billing/discounts',
			element: (
				<React.Suspense fallback={<>...</>}>
					<DiscountsPage />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default DiscountsConfig;
